import { render } from "./FooterBar.vue?vue&type=template&id=01834543"
import script from "./FooterBar.vue?vue&type=script&lang=js"
export * from "./FooterBar.vue?vue&type=script&lang=js"

import "./FooterBar.vue?vue&type=style&index=0&id=01834543&lang=css"
script.render = render

export default script